import { useQuery } from '@tanstack/react-query';
import { collection, getDocs, orderBy, query } from 'firebase/firestore';
import { firestore } from '../services/firebase';
import { PRODUCT_CATEGORIES } from '../constants/entities';

/**
 * Categorias de produtos (prateleiras da vitrine, ex.: "Cursos teóricos",
 * "Formações"). Criadas/vinculadas direto no formulário de cada produto (ver
 * ProductCategoryPicker) — não existe uma tela dedicada de CRUD.
 */
export const useProductCategories = () => {
  return useQuery({
    queryKey: [PRODUCT_CATEGORIES],
    queryFn: async () => {
      const snap = await getDocs(
        query(collection(firestore, PRODUCT_CATEGORIES), orderBy('order', 'asc'))
      );
      return snap.docs
        .map((d) => ({ id: d.id, ...d.data() }))
        .filter((category) => !category.archived);
    },
  });
};
